import { get, isFunction } from 'lodash';
import PropTypes from 'prop-types';

import longText from './longText';
import nextButton from './nextButton';
import questionDropdown from './questionDropdown';
import questionImageMulti from './questionImageMulti';
import questionImageSingle from './questionImageSingle';
import questionMatrixMulti from './questionMatrixMulti';
import questionMatrixRadio from './questionMatrixRadio';
import questionMatrixScale from './questionMatrixScale';
import questionMulti from './questionMulti';
import questionNumeric from './questionNumeric';
import questionScale from './questionScale';
import questionSingle from './questionSingle';
import redirectButton from './redirectButton';
import respondentBlankField from './respondentBlankField';
import respondentCompanyName from './respondentCompanyName';
import respondentFirstName from './respondentFirstName';
import respondentInfoLongText from './respondentInfoLongText';
import respondentInfoQuestionDropdown from './respondentInfoQuestionDropdown';
import respondentInfoQuestionMulti from './respondentInfoQuestionMulti';
import respondentInfoQuestionRadio from './respondentInfoQuestionRadio';
import respondentInfoShortText from './respondentInfoShortText';
import respondentLastName from './respondentLastName';
import respondentMail from './respondentMail';
import respondentPhone from './respondentPhone';
import shortText from './shortText';
import socialFollow from './socialFollow';
import staticText from './staticText';
import submitButton from './submitButton';

const blockConfig = {
  [respondentBlankField.type]: respondentBlankField,
  [respondentInfoQuestionDropdown.type]: respondentInfoQuestionDropdown,
  [respondentInfoLongText.type]: respondentInfoLongText,
  [respondentInfoShortText.type]: respondentInfoShortText,
  [respondentInfoQuestionMulti.type]: respondentInfoQuestionMulti,
  [respondentInfoQuestionRadio.type]: respondentInfoQuestionRadio,
  [respondentCompanyName.type]: respondentCompanyName,
  [respondentMail.type]: respondentMail,
  [respondentFirstName.type]: respondentFirstName,
  [respondentLastName.type]: respondentLastName,
  [respondentPhone.type]: respondentPhone,
  [questionDropdown.type]: questionDropdown,
  [shortText.type]: shortText,
  [longText.type]: longText,
  [questionMulti.type]: questionMulti,
  [nextButton.type]: nextButton,
  [questionScale.type]: questionScale,
  [questionNumeric.type]: questionNumeric,
  [redirectButton.type]: redirectButton,
  [socialFollow.type]: socialFollow,
  [staticText.type]: staticText,
  [submitButton.type]: submitButton,
  [questionSingle.type]: questionSingle,
  [questionMatrixRadio.type]: questionMatrixRadio,
  [questionMatrixMulti.type]: questionMatrixMulti,
  [questionMatrixScale.type]: questionMatrixScale,
  [questionImageSingle.type]: questionImageSingle,
  [questionImageMulti.type]: questionImageMulti,
};

// @TODO extract functions to utils @sinslav

export const getQuestionConfig = type => get(blockConfig, type, null);

export const getBlockDefaultProps = type =>
  getQuestionConfig(type).getDefaultProps();

export const getQuestionConfigSettings = type =>
  get(getQuestionConfig(type), 'settings', {});

// @note limitations describes any restrictions for correspondent field in questions schema @sinslav
export const getQuestionConfigLimits = type =>
  get(getQuestionConfig(type), 'limits', {});

export const getQuestionPropTypes = type =>
  PropTypes.shape(get(getQuestionConfigSettings(type), 'blockPropTypes', {}));

export const getQuestionLogicOptions = question => {
  if (question) {
    const toLogicOptions = getQuestionConfig(question.type).toLogicOptions;

    if (isFunction(toLogicOptions)) {
      return toLogicOptions(question) || [];
    }
  }

  return [];
};

export default blockConfig;
